/* tslint:disable */
/* eslint-disable */
export enum GatewayEnum {
  RC = 'RC',
  CloverPos = 'CloverPos',
  CloverEcomm = 'CloverEcomm',
  PayPal = 'PayPal'
}
